import React, { Fragment } from "react";
import Navbar from "../components/Navbar/Navbar";
import { ContentUnitMenu } from "../data/contentUnitMenu";

const ContentUnitLayout = ({ children }) => {
  return (
    <Fragment>
      <Navbar menuList={ContentUnitMenu} />
      {children}
    </Fragment>
  );
};


export default ContentUnitLayout;